import { ShoppingBag } from "lucide-react";
import { useOrder } from "@/context/CartContext";

export default function StickyMobileOrder() {
  const { openWith, inventory } = useOrder();
  const soldOut = inventory.all_sold_out;
  return (
    <div className="md:hidden fixed bottom-4 inset-x-4 z-30">
      <button
        type="button"
        onClick={() => openWith(null)}
        data-testid="mobile-sticky-order-button"
        className={`w-full inline-flex items-center justify-center gap-2 font-bold uppercase tracking-[0.18em] px-5 py-4 rounded-full transition-all ${
          soldOut
            ? "bg-[#171D4F] text-[#F6F0E8] border border-[#F6F0E8]/15"
            : "bg-[#ED0B09] text-[#F6F0E8] shadow-[0_14px_38px_rgba(237,11,9,0.55)] animate-pulse-glow"
        }`}
      >
        <ShoppingBag size={18} />
        {soldOut ? "Drop Sold Out" : "Pre-order Now · From $15"}
      </button>
    </div>
  );
}
